import { useSelector } from 'react-redux'
import { DefaultToastContainer, ToastProvider } from 'react-toast-notifications'

const ToastContainer = props => {
  const { isFixed } = useSelector(s => s.header)

  return (
    <DefaultToastContainer
      className="toast-container"
      style={{
        position: 'fixed',
        top: isFixed ? 100 : 0,
        right: 0,
        zIndex: 11000
      }}
      {...props}
    />
  )
}

const Provider = ({ children }) => (
  <ToastProvider autoDismiss={true} components={{ ToastContainer }}>
    {children}
  </ToastProvider>
)

export default Provider
